<template>
<div class="row">
    <div class="mb-3 col-12 col-md-8 offset-md-2">
        <label for="favicon">Favicon</label>
        <ImageUpload
            :file-path="page.favicon"
            @uploadCompleted="storeFavicon"
            @fileDeleted="deleteFavicon"
        ></ImageUpload>
    </div>

    <div class="mb-3 col-12 col-md-8 offset-md-2">
        <label for="logo">Logo</label>
        <ImageUpload
            :file-path="page.logo"
            @uploadCompleted="storeLogo"
            @fileDeleted="deleteLogo"
        ></ImageUpload>
    </div>

    <div class="mb-3 col-12 col-md-8 offset-md-2">
        <label for="og_image">Facebook og:image</label>
        <ImageUpload
            :file-path="page.og_image"
            @uploadCompleted="storeOgImage"
            @fileDeleted="deleteOgImage"
        ></ImageUpload>
        <small class="text-muted">{{'Recommended size:' | translate}} 1200 x 630, 1MB. {{'Optimized images.' | translate}}</small>
    </div>
</div>
</template>

<script>
import route from './../routes.js'
import ImageUpload from './ImageUpload'

export default {
    components: {
        ImageUpload,
    },
    props: [
        'page',
    ],
    data(){return {
    }},
    mounted(){
    },
    methods: {
        deleteFavicon() {
            this.page.favicon = null
            this.updatePage()
        },
        deleteLogo() {
            this.page.logo = null
            this.updatePage()
        },
        deleteOgImage() {
            this.page.og_image = null
            this.updatePage()
        },
        storeFavicon(filePath) {
            this.page.favicon = filePath
            this.updatePage()
        },
        storeOgImage(filePath) {
            this.page.og_image = filePath
            this.updatePage()
        },
        storeLogo(filePath) {
            this.page.logo = filePath
            this.updatePage()
        },
        updatePage() {
            axios.put(route.page(this.page).update, {
                favicon: this.page.favicon,
                logo: this.page.logo,
                og_image: this.page.og_image,
            })
        },
        img(url){
            if (!url) {
                return false
            }
            return route.image(url)
        },
    },
}
</script>

<style>
</style>